import { useState, useCallback } from 'react';

export const usePersistedState = (key, initial) => {
  const [value, setValue] = useState(() => {
    const raw = localStorage.getItem(key);
    if (raw === null) return typeof initial === 'function' ? initial() : initial;
    try { return JSON.parse(raw); } catch { return raw; }
  });
  const set = useCallback((next) => {
    setValue((prev) => {
      const resolved = typeof next === 'function' ? next(prev) : next;
      localStorage.setItem(key, JSON.stringify(resolved));
      return resolved;
    });
  }, [key]);
  return [value, set];
};
